/** Normalise Furp API Result envelopes (LowercaseResponseMiddleware lowercases the whole JSON). */

export function apiField(obj: any, ...names: string[]): any {
  if (obj == null || typeof obj !== "object") return undefined;
  for (const name of names) {
    if (Object.prototype.hasOwnProperty.call(obj, name) && obj[name] !== undefined) {
      return obj[name];
    }
    const want = String(name).toLowerCase();
    for (const key of Object.keys(obj)) {
      if (key.toLowerCase() === want && obj[key] !== undefined) return obj[key];
    }
  }
  return undefined;
}

export function apiData<T = any>(payload: any): T | null {
  if (payload == null) return null;
  const nested = apiField(payload, "data", "Data");
  if (nested !== undefined) return nested as T;
  return payload as T;
}

export function apiBool(obj: any, name: string, defaultValue = false): boolean {
  const v = apiField(obj, name);
  if (v === undefined || v === null) return defaultValue;
  if (typeof v === "boolean") return v;
  if (typeof v === "string") return v.toLowerCase() === "true";
  return !!v;
}

export function apiFailed(res: any): boolean {
  if (res?.error) return true;
  const p = res?.payload;
  if (!p) return false;
  const rt = String(apiField(p, "responseType", "ResponseType") ?? "").toLowerCase();
  if (rt === "error") return true;
  const code = apiField(p, "code", "Code");
  return code != null && code !== 200;
}

export function apiMessage(res: any, fallback = "Something went wrong."): string {
  if (typeof res?.payload === "string" && res.payload.trim()) return res.payload;
  if (typeof res?.error === "string") return res.error;
  if (res?.error?.message) return res.error.message;
  const p = res?.payload;
  const msg = apiField(p, "message", "Message");
  if (msg) return String(msg);
  const messages = apiField(p, "messages", "Messages");
  if (Array.isArray(messages) && messages[0]) return String(messages[0]);
  return fallback;
}
